export const GET_REVENUE_CENTERS_REQUESTED =
  'GET_REVENUE_CENTERS_REQUESTED'
export const GET_REVENUE_CENTERS_SUCCEEDED =
  'GET_REVENUE_CENTERS_SUCCEEDED'
export const GET_REVENUE_CENTERS_FAILED = 'GET_REVENUE_CENTERS_FAILED'

export const CREATE_REVENUE_CENTERS_REQUESTED =
  'CREATE_REVENUE_CENTERS_REQUESTED'
export const CREATE_REVENUE_CENTERS_SUCCEEDED =
  'CREATE_REVENUE_CENTERS_SUCCEEDED'
export const CREATE_REVENUE_CENTERS_FAILED =
  'CREATE_REVENUE_CENTERS_FAILED'

export const UPDATE_REVENUE_CENTERS_REQUESTED =
  'UPDATE_REVENUE_CENTERS_REQUESTED'
export const UPDATE_REVENUE_CENTERS_SUCCEEDED =
  'UPDATE_REVENUE_CENTERS_SUCCEEDED'
export const UPDATE_REVENUE_CENTERS_FAILED =
  'UPDATE_REVENUE_CENTERS_FAILED'

// Paginated and filtered Revenue Centers //

export const GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_REQUESTED =
  'GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_REQUESTED'
export const GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_SUCCEEDED =
  'GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_SUCCEEDED'
export const GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_FAILED =
  'GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_FAILED'

// AVAILABILITY

export const GET_AVAILABILITY_REQUESTED = 'GET_AVAILABILITY_REQUESTED'
export const GET_AVAILABILITY_SUCCEEDED = 'GET_AVAILABILITY_SUCCEEDED'
export const GET_AVAILABILITY_FAILED = 'GET_AVAILABILITY_FAILED'

// IMAGE OPTIMISTIC RESPONSE

export const SET_REVENUE_CENTER_OPTIMISTIC_LIST_IMAGE =
  'SET_REVENUE_CENTER_OPTIMISTIC_LIST_IMAGE'
